import React from 'react';
import { validationClasses } from '@/utils/errors';
import MarkdownEditor from '@/components/text-editors/MarkdownEditor';

const FormMarkdown = ({
  text,
  onChange,
  disabled,
  autoFocus,
  error,
}) => (
  <MarkdownEditor
    autoFocus={autoFocus}
    disabled={disabled}
    value={text || ''}
    onChange={onChange}
    className={validationClasses(error, 'aridhia-form-markdown aridhia-h3 aridhia-is-edit-mode min-h-135')}
    maxEditorHeight={100}
    minPreviewHeight={80}
  />
);

export default FormMarkdown;
